// i18n เฟส A — UI strings TH/EN (default TH, persist localStorage 'bb-lang')
// ใช้: const { t, x, lang, setLang } = useI18n()
//   t('key', ...args)  → string จาก dict (แทน {0},{1} ด้วย args)
//   x(serverString)    → แปล string ที่มาจาก DB/API (label ค่าส่ง ฯลฯ) ถ้ามีใน EXACT
// เนื้อหาสินค้า (blurb) + หน้า policy ยังเป็นไทย — เฟส B
import { createContext, useCallback, useContext, useEffect, useState } from 'react';

// [th, en]
const D = {
  // ---- chrome ----
  'banner.free': ['ส่งฟรีทั่วประเทศเมื่อสั่งครบ {0}', 'Free shipping in Thailand over {0}'],
  'footer.blurb': ['Everyday essentials ที่สร้างมาเพื่อการใช้งานยาวนาน — cast iron, vintage-inspired lighting และเครื่องมือกลางแจ้ง', 'Everyday essentials built to last — cast iron, vintage-inspired lighting and outdoor tools'],
  'footer.shop': ['ช้อป', 'Shop'],
  'footer.help': ['ช่วยเหลือ', 'Help'],
  'footer.contact': ['ติดต่อ', 'Contact'],
  'footer.all': ['สินค้าทั้งหมด', 'All products'],
  'footer.track': ['ตรวจสอบคำสั่งซื้อ', 'Track order'],
  'footer.shipret': ['การจัดส่ง & คืนสินค้า', 'Shipping & returns'],
  'footer.payment': ['วิธีชำระเงิน', 'Payment methods'],
  'footer.howto': ['วิธีสั่งซื้อ & ติดตามพัสดุ', 'How to order & tracking'],
  'footer.faq': ['คำถามที่พบบ่อย', 'FAQ'],

  // ---- cart drawer ----
  'cart.title': ['ตะกร้า', 'Cart'],
  'cart.aria': ['ตะกร้าสินค้า', 'Shopping cart'],
  'cart.empty': ['ยังไม่มีสินค้าในตะกร้า', 'Your cart is empty'],
  'cart.start': ['เริ่มช้อป', 'Start shopping'],
  'cart.remove': ['ลบออก', 'Remove'],
  'cart.subtotal': ['ยอดสินค้า', 'Subtotal'],
  'cart.ship': ['ค่าจัดส่ง', 'Shipping'],
  'cart.shipLater': ['คำนวณตอนชำระเงิน', 'Calculated at checkout'],
  'cart.total': ['รวม', 'Total'],
  'cart.checkout': ['ดำเนินการชำระเงิน →', 'Proceed to checkout →'],

  // ---- toasts (store) ----
  'toast.added': ['เพิ่มลงตะกร้าแล้ว', 'Added to cart'],
  'toast.sold': ['สินค้าหมดชั่วคราว', 'Temporarily out of stock'],
  'toast.ask': ['กรุณาสอบถามราคาสินค้านี้', 'Please contact us for the price'],
  'toast.cartEmpty': ['ตะกร้าว่างอยู่', 'Your cart is empty'],

  // ---- home ----
  'home.lede': ['เครื่องมือและของใช้ที่ออกแบบมาเพื่อการใช้งานยาวนาน — จากหม้อ cast iron และตะเกียง vintage ไปจนถึงเครื่องมือสวนและครัวกลางแจ้ง', 'Tools and everyday goods designed to last — from cast iron cookware and vintage lanterns to garden and outdoor kitchen tools'],
  'home.shopAll': ['ช้อปทั้งหมด →', 'Shop all →'],
  'home.thesis.beautiful': ['ดีไซน์ vintage คลาสสิก งานประณีต', 'Classic vintage design, finely crafted'],
  'home.thesis.durable': ['แข็งแรง ทนทาน ใช้งานยาวนาน', 'Strong, rugged, made to last'],
  'home.thesis.essential': ['ของใช้จำเป็นทุกวัน', 'Essentials for every day'],
  'home.browse': ['เลือกชม →', 'Browse →'],
  'home.featured': ['Featured · คัดสรร', 'Featured · Curated'],
  'home.viewAll': ['ดูทั้งหมด', 'View all'],
  'home.authentic': ['Barebones คือแบรนด์ต้นฉบับจากสหรัฐฯ ที่ออกแบบตะเกียง เครื่องมือ และของใช้สไตล์ vintage-industrial ให้สวยงามและทนใช้งานยาวนาน จัดจำหน่ายในไทยโดย CAMP STUDIO พร้อมการรับประกันและบริการดูแลหลังการขาย', 'Barebones is the original brand from the USA — vintage-industrial lanterns, tools and living goods that are beautiful and built to last. Distributed in Thailand by CAMP STUDIO with full warranty and after-sales care'],
  'home.f1.t': ['จัดส่งทั่วโลก', 'Worldwide shipping'],
  'home.f1.d': ['ส่งถึงทั่วโลกด้วยไปรษณีย์ไทย คิดค่าจัดส่งตามน้ำหนักและปลายทาง', 'Ships worldwide via Thailand Post — rates by weight and destination'],
  'home.f2.t': ['คุณภาพระดับมืออาชีพ', 'Professional quality'],
  'home.f2.d': ['วัสดุพรีเมียม ทั้ง cast iron, stainless steel และไม้จริง ออกแบบให้ใช้งานยาวนาน', 'Premium materials — cast iron, stainless steel and real wood, designed to last'],
  'home.f3.t': ['รับประกัน 1 ปี', '1-year warranty'],
  'home.f3.d': ['รับประกันความชำรุดจากการผลิต 1 ปี พร้อมบริการดูแลหลังการขาย', 'One-year warranty against manufacturing defects, plus after-sales service'],

  // ---- category taglines (CATS.d / CATS.mood เป็นไทยใน data) ----
  'cat.power-light.d': ['ตะเกียง โคมไฟ vintage และไฟพกพา', 'Lanterns, vintage lamps and portable light'],
  'cat.tools.d': ['มีด เครื่องมือสวน และอุปกรณ์ไฟ', 'Knives, garden tools and fire gear'],
  'cat.cook-dine.d': ['cast iron เตาย่าง และของใช้บนโต๊ะ', 'Cast iron, grills and tableware'],
  'cat.store-carry.d': ['เก้าอี้ โต๊ะ และกระเป๋าผ้าใบ', 'Chairs, tables and canvas bags'],
  'cat.power-light.mood': ['แสงอบอุ่นแบบไส้หลอดคลาสสิก สำหรับค่ำคืนกลางแจ้งและมุมโปรดในบ้าน', 'Warm filament-style glow for nights outdoors and favorite corners at home'],
  'cat.tools.mood': ['เหล็กกล้าเคลือบและ accent ทองแดง เครื่องมือที่ออกแบบมาให้ใช้ได้ทั้งชีวิต', 'Coated steel with copper accents — tools designed to last a lifetime'],
  'cat.cook-dine.mood': ['จาก open-fire ถึงโต๊ะอาหาร — cast iron ที่ยิ่งใช้ยิ่งสวย', 'From open fire to the table — cast iron that gets better with use'],
  'cat.store-carry.mood': ['เฟอร์นิเจอร์พับได้และกระเป๋าผ้าใบทนทาน สำหรับพกพาและจัดเก็บ', 'Folding furniture and rugged canvas bags for carrying and storage'],

  // ---- category page ----
  'bc.home': ['หน้าแรก', 'Home'],
  'cat.all': ['สินค้าทั้งหมด', 'All products'],
  'cat.allSub': ['สินค้า Barebones ทั้งหมด', 'The complete Barebones range'],
  'cat.items': ['{0} รายการ', '{0} items'],
  'cat.filterAll': ['ทั้งหมด', 'All'],

  // ---- product card / pdp ----
  'card.choose': ['เลือกตัวเลือก', 'Choose options'],
  'card.add': ['เพิ่มลงตะกร้า', 'Add to cart'],
  'pdp.ask': ['สอบถามราคา', 'Ask for price'],
  'pdp.notFound': ['ไม่พบสินค้า', 'Product not found'],
  'pdp.notFoundSub': ['สินค้านี้อาจถูกปิดการขายแล้ว', 'This product may no longer be available'],
  'pdp.viewAll': ['ดูสินค้าทั้งหมด', 'View all products'],
  'pdp.product': ['สินค้า', 'Products'],
  'pdp.color': ['สี · Color — {0}', 'Color — {0}'],
  'pdp.soldOut': ['สินค้าหมดชั่วคราว', 'Temporarily out of stock'],
  'pdp.add': ['เพิ่มลงตะกร้า · {0}', 'Add to cart · {0}'],
  'pdp.shipWorld': ['ส่งทั่วโลกด้วยไปรษณีย์ไทย', 'Ships worldwide via Thailand Post'],
  'pdp.spec.cat': ['หมวดหมู่', 'Category'],
  'pdp.spec.weight': ['น้ำหนัก', 'Weight'],
  'pdp.spec.warranty': ['การรับประกัน', 'Warranty'],
  'pdp.related.sub': ['Related · ในหมวดเดียวกัน', 'Related · Same collection'],
  'pdp.related.h': ['สินค้าที่เกี่ยวข้อง', 'Related products'],
  'pdp.related.view': ['ดู {0}', 'View {0}'],
  'pdp.foryou.sub': ['For you · แนะนำ', 'For you · Recommended'],
  'pdp.foryou.h': ['สินค้าที่คุณอาจจะชอบ', 'You may also like'],

  // ---- search ----
  'search.ph': ['ค้นหาสินค้า… (เช่น ตะเกียง, cast iron, มีด)', 'Search products… (e.g. lantern, cast iron, knife)'],
  'search.min': ['พิมพ์อย่างน้อย 2 ตัวอักษรเพื่อค้นหา', 'Type at least 2 characters to search'],
  'search.none': ['ไม่พบสินค้าที่ตรงกับ “{0}”', 'No products match “{0}”'],
  'search.sold': [' · หมดชั่วคราว', ' · Out of stock'],
  'search.top12': ['แสดง 12 รายการแรก — พิมพ์ให้เจาะจงขึ้นเพื่อผลลัพธ์ที่ตรงกว่า', 'Showing first 12 — refine your search for closer matches'],

  // ---- checkout ----
  'co.title': ['ชำระเงิน', 'Checkout'],
  'co.continue': ['← ช้อปต่อ', '← Continue shopping'],
  'co.s1': ['1 · ข้อมูลผู้รับ', '1 · Contact details'],
  'co.first': ['ชื่อ', 'First name'],
  'co.last': ['นามสกุล', 'Last name'],
  'co.email': ['อีเมล', 'Email'],
  'co.phone': ['เบอร์โทร', 'Phone'],
  'co.s2': ['2 · วิธีรับสินค้า', '2 · Delivery method'],
  'co.shipHome': ['จัดส่งถึงบ้าน', 'Ship to address'],
  'co.shipHomeSub': ['ไปรษณีย์ไทย EMS · ทั่วประเทศและต่างประเทศ', 'Thailand Post EMS · domestic & international'],
  'co.pickup': ['รับหน้าร้าน CAMP STUDIO', 'Pick up at CAMP STUDIO'],
  'co.pickupSub': ['สุขุมวิท 71 · 10:30–19:30 น. · ไม่เสียค่าจัดส่ง', 'Sukhumvit 71 · 10:30–19:30 · no shipping fee'],
  'co.freeWord': ['ฟรี', 'Free'],
  'co.s3': ['3 · ที่อยู่จัดส่ง', '3 · Shipping address'],
  'co.country': ['ประเทศ / ปลายทาง', 'Country / destination'],
  'co.addr': ['ที่อยู่', 'Address'],
  'co.addrPh': ['บ้านเลขที่ / ถนน / อาคาร', 'House no. / street / building'],
  'co.dist': ['เขต/อำเภอ', 'District'],
  'co.distPh': ['อำเภอ/เขต', 'District'],
  'co.prov': ['จังหวัด/รัฐ', 'Province / state'],
  'co.provPh': ['จังหวัด', 'Province'],
  'co.zip': ['รหัสไปรษณีย์', 'Postal code'],
  'co.s4': ['4 · วิธีจัดส่ง', '4 · Shipping method'],
  'co.quoting': ['กำลังคำนวณค่าจัดส่ง…', 'Calculating shipping…'],
  'co.freeShip': ['ส่งฟรี · ไปรษณีย์ไทย EMS', 'Free shipping · Thailand Post EMS'],
  'co.freeShipSub': ['ยอดสั่งซื้อถึง {0} · ในประเทศ', 'Orders over {0} · domestic'],
  'co.note': ['หมายเหตุถึงร้าน (ถ้ามี)', 'Note to store (optional)'],
  'co.notePhPickup': ['เช่น จะเข้ามารับวันเสาร์ช่วงบ่าย', 'e.g. picking up Saturday afternoon'],
  'co.notePhShip': ['เช่น ฝากไว้ที่ รปภ. / โทรก่อนส่ง', 'e.g. leave with security / call before delivery'],
  'co.sPay': ['{0} · การชำระเงิน', '{0} · Payment'],
  'co.transfer': ['โอนเงิน + แนบสลิป', 'Bank transfer + slip'],
  'co.transferNote': ['หลังยืนยันคำสั่งซื้อ ระบบจะแสดงเลขบัญชีและช่องแนบสลิป', 'After you place the order, we show the bank account and a slip upload'],
  'co.card': ['บัตรเครดิต / เดบิต', 'Credit / debit card'],
  'co.cardNote': ['ระบบจะพาไปหน้าชำระเงินของ Stripe (ปลอดภัย, รองรับ Visa / Mastercard / JCB)', 'You will be redirected to Stripe secure checkout (Visa / Mastercard / JCB)'],
  'co.promptpay': ['บัตรเครดิต / เดบิต · พร้อมเพย์', 'Card · PromptPay'],
  'co.soon': ['เร็วๆ นี้', 'Coming soon'],
  'co.place': ['ยืนยันคำสั่งซื้อ · {0}', 'Place order · {0}'],
  'co.placing': ['กำลังส่งคำสั่งซื้อ…', 'Placing order…'],
  'co.summary': ['สรุปคำสั่งซื้อ', 'Order summary'],
  'co.pickupRow': ['รับหน้าร้าน', 'Store pickup'],
  'co.shipRow': ['ค่าจัดส่ง', 'Shipping'],
  'co.shipRowFree': ['ค่าจัดส่ง (ฟรี)', 'Shipping (free)'],
  'co.grand': ['รวมทั้งสิ้น', 'Total'],
  'co.dest': ['ปลายทาง: {0}', 'Destination: {0}'],
  'co.pickupAt': ['รับสินค้า: CAMP STUDIO สุขุมวิท 71 (10:30–19:30 น.)', 'Pickup: CAMP STUDIO Sukhumvit 71 (10:30–19:30)'],
  'co.emailNote': ['ยืนยันคำสั่งซื้อจะส่งไปที่อีเมลลูกค้า', 'Order confirmation will be emailed to you'],
  'co.needName': ['กรุณากรอกชื่อและอีเมล', 'Please enter your name and email'],
  'co.needAddr': ['กรุณากรอกที่อยู่และรหัสไปรษณีย์', 'Please enter your address and postal code'],
  'co.fail': ['สั่งซื้อไม่สำเร็จ กรุณาลองใหม่ หรือติดต่อ {0}', 'Order failed — please try again or contact {0}'],

  // ---- confirm / order ----
  'conf.paid': ['ชำระเงินเรียบร้อย', 'Payment received'],
  'conf.pay': ['กรุณาชำระเงิน', 'Please complete payment'],
  'conf.waiting': ['รอยืนยันการชำระ', 'Awaiting payment confirmation'],
  'conf.order': ['คำสั่งซื้อ · {0}', 'Order · {0}'],
  'conf.loading': ['กำลังโหลดคำสั่งซื้อ…', 'Loading order…'],
  'conf.notFound': ['ไม่พบคำสั่งซื้อ', 'Order not found'],
  'conf.notFoundNo': ['ไม่พบคำสั่งซื้อ {0}', 'Order {0} not found'],
  'conf.test': ['โหมดทดสอบ — คำสั่งซื้อนี้ยังไม่ถูกบันทึกจริง (backend ยังไม่เชื่อมต่อ)', 'Test mode — this order was not saved (backend not connected)'],
  'conf.trackingNo': ['เลขพัสดุ:', 'Tracking no:'],
  'conf.paidBody1': ['เราได้รับเงินเรียบร้อยแล้ว', 'We have received your payment'],
  'conf.paidBody2': ['รายละเอียดและสถานะการจัดส่งจะถูกส่งไปยังอีเมลของคุณ', 'Details and shipping updates will be sent to your email'],
  'conf.trackLink': ['ตรวจสอบสถานะคำสั่งซื้อ', 'Track your order'],
  'conf.contact': ['มีคำถาม ติดต่อ', 'Questions? Contact'],
  'conf.bank': ['ธนาคาร', 'Bank'],
  'conf.acct': ['เลขบัญชี', 'Account no.'],
  'conf.holder': ['ชื่อบัญชี', 'Account name'],
  'conf.amount': ['ยอดโอน', 'Amount'],
  'conf.slipTap': ['แตะเพื่อแนบสลิปโอนเงิน', 'Tap to attach your transfer slip'],
  'conf.slipReady': ['✓ แนบสลิปแล้ว — พร้อมส่งตรวจ', '✓ Slip attached — ready to verify'],
  'conf.slipTypes': ['รองรับ .jpg / .png', '.jpg / .png supported'],
  'conf.slipSend': ['ส่งสลิปตรวจสอบ', 'Submit slip'],
  'conf.slipChecking': ['กำลังตรวจสอบ…', 'Verifying…'],
  'conf.slipRetry': ['ลองแนบสลิปใหม่', 'Try another slip'],
  'conf.slipAuto': ['◈ ระบบตรวจสอบยอด/บัญชี/เวลาโอนอัตโนมัติ', '◈ Amount / account / time verified automatically'],
  'conf.slipFail': ['ส่งสลิปไม่สำเร็จ กรุณาลองใหม่', 'Slip upload failed — please try again'],
  'conf.stripeLede': ['ชำระเงิน{0} ผ่าน Stripe (Visa / Mastercard / JCB)', 'Pay{0} via Stripe (Visa / Mastercard / JCB)'],
  'conf.payCard': ['ชำระด้วยบัตร →', 'Pay by card →'],
  'conf.stripeSecure': ['ระบบจะพาไปหน้าชำระเงินของ Stripe ที่ปลอดภัย', 'You will be redirected to Stripe secure checkout'],
  'conf.track': ['ตรวจสอบคำสั่งซื้อ', 'Track order'],
  'conf.home': ['กลับหน้าแรก', 'Back to home'],
  'conf.comeback': ['กลับมาแนบสลิปภายหลังได้ที่ Track Order ด้วยหมายเลข {0}', 'You can attach the slip later via Track Order using order no. {0}'],

  // ---- track ----
  'track.h': ['ตรวจสอบคำสั่งซื้อ', 'Track your order'],
  'track.orderNo': ['หมายเลขคำสั่งซื้อ', 'Order number'],
  'track.orderNoPh': ['เช่น BB2607100001', 'e.g. BB2607100001'],
  'track.email': ['อีเมลที่ใช้สั่งซื้อ', 'Email used at checkout'],
  'track.find': ['ค้นหาคำสั่งซื้อ', 'Find order'],
  'track.finding': ['กำลังค้นหา…', 'Searching…'],
  'track.none': ['ไม่พบคำสั่งซื้อ', 'Order not found'],
  'track.noneSub': ['ตรวจสอบหมายเลขคำสั่งซื้อและอีเมลให้ถูกต้อง', 'Check that the order number and email are correct'],
  'track.orderedAt': ['สั่งซื้อเมื่อ {0}', 'Ordered {0}'],
  'track.trackingNo': ['เลขพัสดุ', 'Tracking number'],
  'track.shippedAt': ['จัดส่งเมื่อ {0}', 'Shipped {0}'],
  'track.lines': ['รายการสินค้า', 'Items'],
  'track.shipFree': ['ค่าจัดส่ง (ฟรี)', 'Shipping (free)'],
  'track.grand': ['รวมทั้งสิ้น', 'Total'],
  'track.bankInfo': ['ข้อมูลการโอนเงิน', 'Bank transfer details'],
  'track.paidAt': ['ชำระเงินเมื่อ {0}', 'Paid {0}'],
  'track.viaTransfer': [' · โอนเงิน', ' · bank transfer'],
  'track.contactQ': ['มีคำถาม? ติดต่อ', 'Questions? Contact'],
  'track.back': ['← กลับหน้าแรก', '← Back to home'],
  'st.awaiting_payment': ['รอชำระเงิน', 'Awaiting payment'],
  'st.pending': ['รอดำเนินการ', 'Processing'],
  'st.paid': ['ชำระเงินแล้ว · รอจัดส่ง', 'Paid · preparing shipment'],
  'st.shipped': ['จัดส่งแล้ว', 'Shipped'],
  'st.cancelled': ['ยกเลิก', 'Cancelled'],
  'st.failed': ['ล้มเหลว', 'Failed'],
  'step.await': ['รอชำระ', 'Payment'],
  'step.paid': ['ชำระแล้ว', 'Paid'],
  'step.shipped': ['จัดส่งแล้ว', 'Shipped'],
};

// server strings (มาจาก DB/seed เป็นไทย) → EN
const EXACT = {
  'ไปรษณีย์ไทย EMS': 'Thailand Post EMS',
  'พัสดุลงทะเบียน': 'Registered mail',
  'EMS World': 'EMS World',
  'ด่วนพิเศษ · 1–2 วันทำการ': 'Express · 1–2 business days',
  'ประหยัด · 3–5 วันทำการ': 'Economy · 3–5 business days',
  'อาเซียนใกล้ · 5–14 วันทำการ': 'Near ASEAN · 5–14 business days',
  'เอเชียตะวันออก · 5–14 วันทำการ': 'East Asia · 5–14 business days',
  'เอเชียใต้/ตะวันออกกลาง/โอเชียเนีย · 5–14 วันทำการ': 'South Asia / Middle East / Oceania · 5–14 business days',
  'ยุโรป/อเมริกาเหนือ · 5–14 วันทำการ': 'Europe / North America · 5–14 business days',
  'ทั่วโลก · 7–21 วันทำการ': 'Worldwide · 7–21 business days',
  'ธนาคารกสิกรไทย (KBank)': 'Kasikornbank (KBank)',
};

const I18nCtx = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    try { return localStorage.getItem('bb-lang') === 'en' ? 'en' : 'th'; } catch { return 'th'; }
  });

  useEffect(() => { document.documentElement.lang = lang; }, [lang]);

  const setLang = useCallback((l) => {
    setLangState(l);
    try { localStorage.setItem('bb-lang', l); } catch { /* private mode */ }
  }, []);

  const t = useCallback((key, ...args) => {
    const e = D[key];
    let s = e ? (lang === 'en' ? e[1] : e[0]) : key;
    args.forEach((a, i) => { s = s.replaceAll(`{${i}}`, String(a)); });
    return s;
  }, [lang]);

  const x = useCallback((s) => (lang === 'en' && s && EXACT[s]) || s, [lang]);

  // ชื่อประเทศ: TH list มาจาก seed (ไทย) — EN ใช้ Intl.DisplayNames
  const countryName = useCallback((code, thaiLabel) => {
    if (lang !== 'en') return thaiLabel;
    if (code === 'TH') return 'Thailand (domestic)';
    if (code === 'OTHER') return 'Other countries';
    try { return new Intl.DisplayNames(['en'], { type: 'region' }).of(code) || thaiLabel; }
    catch { return thaiLabel; }
  }, [lang]);

  return <I18nCtx.Provider value={{ lang, setLang, t, x, countryName }}>{children}</I18nCtx.Provider>;
}

export function useI18n() {
  const ctx = useContext(I18nCtx);
  if (!ctx) throw new Error('useI18n ต้องอยู่ใต้ <I18nProvider>');
  return ctx;
}
